import { render, staticRenderFns } from "./box-loader.vue?vue&type=template&id=1868d790&scoped=true&lang=pug"
import script from "./box-loader.vue?vue&type=script&lang=js"
export * from "./box-loader.vue?vue&type=script&lang=js"
import style0 from "./box-loader.vue?vue&type=style&index=0&id=1868d790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1868d790",
  null
  
)

export default component.exports